import angular from "angular";
import chatModule from '../chatModule';

function togglePopover($log, $document) {
    "ngInject";

    return {
        restrict: 'A',
        replace: true,
        scope: true,
        link: function (scope, element, attrs) {
            const { togglePopoverParams } = scope.dialogLayout;
            var dialogSelector = togglePopoverParams.dialogSelector;
            var triggerSelector = togglePopoverParams.triggerSelector;
            var pinIconClassName = togglePopoverParams.pinIconClassName;
            var dialogTriggerClassSelector = togglePopoverParams.dialogTriggerClassSelector;
            var isExclusiveClickSelector = togglePopoverParams.isExclusiveClickSelector ? togglePopoverParams.isExclusiveClickSelector : "is-exclusive-click";

            element.on('click', function (event) {
                var target = angular.element(event.target);
                if (insideTrigger(target)) {
                    scope.dialogLayout.togglePopoverParams.isOpen = !scope.dialogLayout.togglePopoverParams.isOpen;
                }
            });

            function bindDocumentClick() {
                $document.on("click", function (event) {
                    event.stopPropagation();

                    var target = angular.element(event.target);

                    if (!insideTrigger(target)
                        && !insideDialog(target)
                        && !isExclusive(target)) {
                        scope.dialogLayout.togglePopoverParams.isOpen = false;
                    }

                });
            }
            function insideTrigger(target) {
                var trigger = angular.element(triggerSelector);
                return trigger.is(target) || (trigger.find(target) && trigger.find(target).length > 0);
            }

            function insideDialog(target) {
                var dialog = angular.element(dialogSelector);
                return dialog.find(target) && dialog.find(target).length > 0;
            }

            function isExclusive(target) {
                var isExclusive = false;
                if (isPinIcon(target)) {
                    isExclusive = (scope.dialogData.playTogetherIds && scope.dialogData.playTogetherIds.length > 0)
                        || scope.dialogData.pinGame;

                }
                if (isDialogTrigger(target)) {
                    isExclusive = true;
                }

                if (target.hasClass(isExclusiveClickSelector)) {
                    isExclusive = true;
                }

                return isExclusive;
            }

            function isPinIcon(target) {
                return target.hasClass(pinIconClassName);
            }

            function isDialogTrigger(target) {
                var dialogTrigger = angular.element(dialogTriggerClassSelector);
                return dialogTrigger.is(target) || (dialogTrigger.find(target) && dialogTrigger.find(target).length > 0);
            }

            var watchPlayTogetherIds = scope.$watch(
                function () {
                    return scope.dialogData.playTogetherIds;
                }, function (newValue, oldValue) {
                    if (newValue !== oldValue && newValue && newValue.length > 0) {
                        if (!scope.dialogLayout.togglePopoverParams.isOpen) {
                            scope.dialogLayout.togglePopoverParams.isOpen = true;
                        }
                    }
                }, true);

            var watchDialogFirstTimeOpen = scope.$watch(
                function () {
                    return scope.dialogLayout.togglePopoverParams.isFirstTimeOpen;
                }, function (newValue, oldValue) {
                    if (newValue) {
                        bindDocumentClick();

                    }
                }, true);

            scope.$on('$destroy', function () {
                watchPlayTogetherIds();
                watchDialogFirstTimeOpen();
            });
        }
    }
};

chatModule.directive("togglePopover", togglePopover);

export default togglePopover;